'use client';

import { twJoin, twMerge } from 'tailwind-merge';

import { Pause, Play } from '@videoblocks/react-icons';

type AudioPlayerPlayButtonProps = {
    isPlaying?: boolean;
    className?: string;
    onClick?: () => void;
};

const AudioPlayerPlayButton = ({ onClick, isPlaying = false, className = '' }: AudioPlayerPlayButtonProps) => {
    return (
        <div className="flex">
            <button
                className={twMerge(
                    'flex items-center cursor-pointer justify-center border-none bg-none h-fit self-center rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ',
                    className,
                )}
                onClick={onClick}
                aria-label={isPlaying ? 'pause' : 'play'}
                title={isPlaying ? 'pause' : 'play'}
            >
                <div
                    className={twJoin(
                        'text-white rounded-full flex justify-center items-center w-[3.25rem] h-[3.25rem] group-hover:bg-blue-700',
                        isPlaying ? 'bg-blue-700' : 'bg-gray-600',
                    )}
                >
                    {isPlaying ? <Pause className="fill-current w-5" /> : <Play className="fill-current w-5" />}
                </div>
            </button>
        </div>
    );
};

export default AudioPlayerPlayButton;
